import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arraw-right",
  "use": "icon-arraw-right-usage",
  "viewBox": "0 0 6 12",
  "content": "<symbol viewBox=\"0 0 6 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arraw-right\">\n<path d=\"M1.19751 10.6199L5.00084 6.81655C5.45001 6.36738 5.45001 5.63238 5.00084 5.18322L1.19751 1.37988\" stroke=\"white\" stroke-width=\"0.875\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol